export default __webpack_public_path__ + "static/media/P11.a5840c10.png";